/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import * as _ from 'underscore';

class ChooserHeader extends React.Component {
    render() {
        let headerCopy = this.props.headerCopy || '',
            serviceMessage = null,
            error = this.props.error || '',
            errorMsg = error;

        if (this.props.serviceMessage !== undefined && this.props.serviceMessage) {
            serviceMessage = (
                <div className="chooser-notice service-message">
                    {this.props.serviceMessage}
                    <br/><br/>
                </div>
            );
        }

        if (_.isObject(error)) {
            if (error.message) {
                errorMsg = (
                    <div className="chooser-error">
                        <div className="error">
                            <div className="error-headline">{error.message}</div>
                            <div className="error-detail">{error.detail}</div>
                        </div>
                    </div>
                );
            }
        }

        return (
            <div>
                <div className="chooser-header">
                    {headerCopy}
                    {errorMsg}
                </div>
                {serviceMessage}
            </div>
        );
    }
}

ChooserHeader.displayName = "ChooserHeader";

export default ChooserHeader;
